import React, { useEffect, useState, useMemo } from "react";
import { Box, Chip, ListItemIcon, MenuItem, } from "@mui/material";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import { Build, } from "@mui/icons-material";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import MaterialReactTable from "material-react-table";
import moment from "moment";
import AsignarTecnico2 from "../instalaciones/AsignarTecnico2";
import FinalizarReclamo from "../FinalizarReclamo";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR
import UpdatedUploadFiles from "../../../../services/UpdatedUploadFiles";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Facturado from "../Facturado";
import Badge from "@mui/material/Badge";
import CancelarReclamo2 from "../instalaciones/CancelarReclamo2";
import ConfirmarGrua from "../ConfirmarGrua";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import EditarReclamoInst from "../instalaciones/EditarReclamoInst";
import { getData } from "../../../../services/library";
import DetalleReclamo2 from "../instalaciones/DetalleReclamo2";

export default function Desconexiones2(props) {
    const [reclamos, setReclamos] = useState([]);
    let sector = (localStorage.getItem('sector'));
    const [openclose, setopenclose] = useState(false);
    const [tabla, setTabla] = useState(true);
    const [asignar, setAsignar] = useState(false);
    const [dataReclamo, setdataReclamo] = useState({});
    const [confirmarGrua, setConfirmarGrua] = useState(false);
    const [cancelar, setCancelar] = useState(false);
    const [editar, setEditar] = useState(false);
    const [facturar, setFacturar] = useState(false);
    const [finalizar, setFinalizar] = useState(false);
    const categoriasGrua = ["282"];
    const [haytanques, sethayTanques] = useState(false);
    const estadoGruas = ["275", ];
    const categoriaDesinstalaciones = ["282"];
    const estadoDesinstalaciones = ["170", "192", "171", "223", "342", "347","346"];
    const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
    const [cantidadesDesconexiones, setCantidadesDesconexiones] = useState({});
    const [cantidadTanqueDesconexion, setCantidadTanqueDesconexion] = useState(
        []
    );
    const estadosConfig = [
        { key: "abiertos", label: "Abiertos", color: "info", id: 192 },
        { key: "asignados", label: "Asignados", color: "primary", id: 170 },
        { key: "cancelados", label: "Cancelados", color: "error", id: 223 },

        { key: "pendiente_fin", label: "Pendiente finalizacion", color: "warning", id: 342 },
        { key: "en_transito", label: "En tránsito", color: "secondary", id: 346 },
        { key: "en_proceso", label: "En proceso", color: "warning", id: 348 },
        { key: "finalizados", label: "Finalizados", color: "success", id: 171 },
    ];

    const getReclamos = () => {
        const isSector12 = sector === "12";
        const prefix = isSector12 ?
            `/reclamos/all` : `/reclamos/all_comercial`;

        const user = localStorage.getItem('user');

        let categorias = "";
        let estados = "";

        if (props.activeTab === 0) {
            categorias = categoriaDesinstalaciones.join(",");
            estados = estadoDesinstalaciones.join(",");
        } else if (props.activeTab === 1) {
            categorias = categoriasGrua.join(",");
            estados = estadoGruas.join(",");
        };

        const url = isSector12
            ? `${prefix}/${categorias}/${estados}`
            : `${prefix}/${categorias}/${estados}/${user}`;

        getData(url, setReclamos)

        if (props.activeTab === 0) {
            if (sector === "12") {
                getData(`/reclamos/allr/cantidad_reclamos/282`, setCantidadesDesconexiones)
                getData(`/reclamos/cantidadTanqueReemplazo`, setCantidadTanqueDesconexion)

            } else {
                getData(`/reclamos/cantidadReclamosComercial/${user}/282`, setCantidadesDesconexiones)
            }
        }
    };

    useEffect(() => {
        getReclamos();
    }, [props.activeTab, tabla, estadoSeleccionado]);

    useEffect(() => {
        setEstadoSeleccionado(null);
    }, [props.activeTab]);

    const reclamosFiltrados = useMemo(() => {
        if (!estadoSeleccionado) return reclamos;

        return reclamos && reclamos.filter(
            (r) => r.estado === estadoSeleccionado
        );
    }, [reclamos, estadoSeleccionado]);


    //DEFINO LAS COLUMNAS PARA LAS TABLAS
    const getColumnsDesconexion = () => {
        let columns = [
            {
                header: 'OT',
                accessorKey: "id_reclamo",
                maxSize: 50,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "right" }
            },
            {
                header: 'Cliente',
                accessorKey: "id_cliente",
                accessorFn: (c) => c.sisven_id ? `(${c.sisven_id}) ${c.razon_social} ` : `${c.razon_social}`,
                size: 200,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: 'Registrado',
                accessorKey: 'created_at',
                sortingFn: 'datetime',
                Cell: ({ cell }) =>
                    moment(cell.getValue()).format('DD-MM-YYYY'),
                size: 60,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: "Prioridad",
                accessorKey: "valor_prioridad",
                size: 90,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" },
            },
            {
                header: "Instalador",
                accessorKey: "razon_prov",
                size: 100,
                enableColumnFilter: true,
                filterFn: "fuzzy",
                muiTableBodyCellProps: { align: "left" },
            },
            {
                header: "Estado",
                accessorKey: "estado_reclamo",
                size: 85,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" },
            },

            {
                header: "Facturado",
                accessorKey: "facturado",
                accessorFn: (r) => r.facturado === 0 ? "No" : "Si",
                size: 85,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" },
            },
            {
                header: 'Finalizado',
                accessorKey: 'fecha_finalizado',
                sortingFn: (rowA, rowB, columnId) => {
                    const a = rowA.getValue(columnId);
                    const b = rowB.getValue(columnId);

                    if (!a && !b) return 0;
                    if (!a) return 1; // null abajo
                    if (!b) return -1;

                    return new Date(a) - new Date(b);
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value
                        ? moment(value).format('DD-MM-YYYY')
                        : '—';
                },
                size: 90,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "center" },
            },
            {
                header: 'Planta',
                accessorKey: "nombre_sucursal",
                accessorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
                size: 80,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: 'Localidad',
                accessorKey: "localidad",
                // accesorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
                size: 80,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },

        ];
        return columns
    };

    const columnsDesconexion = useMemo(() => getColumnsDesconexion(reclamos), [reclamos]);

    const getColumnsGrua = () => {
        let columnsGrua = [
            {
                header: "OT",
                accessorKey: "id_reclamo",
                maxSize: 50,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "right" },
            },
            {
                header: 'Cliente',
                accessorKey: "id_cliente",
                accessorFn: (c) => c.sisven_id ? `(${c.sisven_id}) ${c.razon_social} ` : `${c.razon_social}`,
                size: 230,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: 'Registrado',
                accessorKey: "created_at",
                accessorFn: (c) => `${moment(c.created_at).format("DD-MM-YYYY")} `,
                size: 100,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: 'Planta',
                accessorKey: "nombre_sucursal",
                accessorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
                size: 80,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: 'Localidad',
                accessorKey: "localidad",
                // accesorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
                size: 100,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" }
            },
            {
                header: "Estado",
                accessorKey: "estado_reclamo",
                size: 85,
                enableColumnFilter: true,
                muiTableBodyCellProps: { align: "left" },
            },
        ];
        return columnsGrua;
    };

    const columnsGrua = useMemo(() => getColumnsGrua(reclamos), [reclamos]);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "5rem", backgroundColor: "#ffffff",mt: 1  },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 },
        // sorting: [{ id: "id_reclamo", desc: true }],
        columnPinning: { right: ["mrt-row-actions"] },
        showColumnFilters: true,
    };

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const customLocalization = {
        ...MRT_Localization_ES,
        expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
        expand: "Ex", // Cambia 'Expandir' a 'Ex'
    };

    const filteredColumns = useMemo(() => {
        switch (props.activeTab) {
            case 0:
                return columnsDesconexion;
            case 1:
                return columnsGrua;

            default:
                return [];
        }
    }, [props.activeTab]);

    const bgcolor = {
        169: '#ffffff',
        170: '#7cc993ff',
        171: "#C3EFD0",
        223: "#cf7754ff",
    };

    useEffect(() => {
        if (dataReclamo?.id_reclamo) {
            const actualizado = reclamos.find(r => r.id_reclamo === dataReclamo.id_reclamo);
            if (actualizado) setdataReclamo(actualizado);
        }
    }, [reclamos]);

    const handleCloseFacturar = (value) => {
        setFacturar(false);
        getReclamos();
    };

    const renderEstadosChips = () => (
        <Box display="flex" gap={2} flexWrap="wrap">
            {estadosConfig.map((estado) => {
                const isActive = estadoSeleccionado === estado.id;
                const count = cantidadesDesconexiones?.[estado.key] ?? 0;

                return (
                    <Chip
                        key={estado.key}
                        label={`${estado.label}: ${count}`}
                        color={isActive ? estado.color : "default"}
                        variant={isActive ? "filled" : "outlined"}
                        clickable
                        sx={{
                            height: 38,
                            borderRadius: "20px",
                            fontWeight: isActive ? 600 : 400,
                            transition: "0.2s",
                            "&:hover": {
                                transform: "translateY(-2px)",
                            },
                        }}
                        onClick={() =>
                            setEstadoSeleccionado((prev) =>
                                prev === estado.id ? null : estado.id
                            )
                        }
                    />
                );
            })}
        </Box>
    );


    return (
        <div>
            {tabla && reclamos &&
                <MaterialReactTable
                    // data={reclamos}
                    data={reclamosFiltrados}
                    columns={filteredColumns}
                    initialState={initialState}
                    enableRowActions={sector !== "13"} // solo activa si no es sector 13
                    enableExpanding={false}
                    enableColumnResizing
                    enableSorting
                      enableFullScreenToggle={false}
                    enableFacetedValues
                    positionActionsColumn="last"
                    enableExpandAll={false}
                    enableToolbarInternalActions
                    muiTableHeadCellProps={tableHeadCellProps}
                    muiTableBodyProps={({ row, column }) => {
                        const value = row?.original?.[column.id];
                        const isNumber = typeof value === "number" && !isNaN(value);
                        return {
                            align: isNumber ? "right" : "left",
                            sx: {
                                backgroundColor: bgcolor[row?.original.estado] ?? "#fff",
                                color: "black",
                                borderColor: "black",
                            },
                        };
                    }}
                    enableColumnActions
                    muiSearchTextFieldProps={muiSearchTextFieldProps}
                    enableDensityToggle={false}
                    layoutMode="semantic"
                    localization={customLocalization}
                    // enableColumnDragging={false}
                    // enableEditing
                    // enablePinning={false}
                    enableHiding={false}
                    enableColumnFilters={false}
                    // enableColumnFilterModes={true}
                    renderDetailPanel={({ row }) => (
                        <DetalleReclamo2
                            datos={row.original}
                            activeTab={props.activeTab}
                            actualizar={getReclamos}
                            reclamos={reclamos}
                            sethayTanques={sethayTanques}
                            haytanques={haytanques}
                        />
                    )}
                    renderTopToolbarCustomActions={({ table }) => (
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                mt: 1,
                            }}
                        >
                            {props.activeTab === 0 && renderEstadosChips()}

                        </Box>
                    )}
                    renderRowActionMenuItems={({ closeMenu, row }) => [
                        <MenuItem
                            disabled={
                                (row.original.estado !== 192)
                            }
                            key={2}
                            onClick={() => {
                                closeMenu();
                                setdataReclamo(row.original);
                                setAsignar(true);
                                // setUuid(uuidv4());
                            }}
                            sx={{ m: 0 }}
                        >
                            <ListItemIcon>
                                <Build color="action" />
                            </ListItemIcon>
                            Asignar Técnico
                        </MenuItem>,
                        <MenuItem
                            disabled={
                                (row.original.id_proveedor === null ||
                                    row.original.estado === 170 || row.original.estado === 171 || row.original.estado === 342 || row.original.estado === 223)
                            }
                            key={0}
                            onClick={() => {
                                closeMenu();
                                setdataReclamo(row.original);
                                setConfirmarGrua(true);
                            }}
                            sx={{ m: 0 }}
                        >
                            <ListItemIcon>
                                <DoneOutlineIcon color="success" />
                            </ListItemIcon>
                            Confirmar Grua
                        </MenuItem>,
                        <MenuItem
                            disabled={
                                row.original.estado !== 170
                            }
                            key={3}
                            onClick={() => {
                                closeMenu();
                                setdataReclamo(row.original);
                                setAsignar(true);
                            }}
                            sx={{ m: 0 }}
                        >
                            <ListItemIcon>
                                <Build color="action" />
                            </ListItemIcon>
                            Reasignar Técnico
                        </MenuItem>,
                        <MenuItem
                            disabled={
                                // row.original.estado !== 170 ||
                                row.original.estado !== 342 ||
                                localStorage.getItem("sector") === "13" // condición del sector (comercial granel no puede verlo)
                            }
                            key={4}
                            onClick={() => {
                                closeMenu();
                                setdataReclamo(row.original);
                                setFinalizar(true);
                            }}
                            sx={{ m: 0 }}
                        >
                            <ListItemIcon>
                                <BeenhereIcon color="success" />
                            </ListItemIcon>
                            Finalizar
                        </MenuItem>,
                        <MenuItem
                            disabled={
                                (row.original.estado !== 192 &&
                                    row.original.estado !== 170 &&
                                    row.original.estado !== 275) ||
                                (row.original.estado === 170 &&
                                    localStorage.getItem("sector") === "13")
                            }
                            key={5}
                            onClick={() => {
                                closeMenu();
                                setdataReclamo(row.original);
                                setCancelar(true);
                            }}
                            sx={{ m: 0 }}
                        >
                            <ListItemIcon>
                                <DoDisturbAltIcon color="error" />
                            </ListItemIcon>
                            Cancelar
                        </MenuItem>,
                        <Badge
                            key={6}
                            color="primary"
                            badgeContent={row.original.total_archivos} // Muestra el número correcto de adjuntos
                            showZero
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            sx={{
                                "& .MuiBadge-badge": {
                                    fontSize: "0.75rem", // Tamaño de fuente más pequeño
                                    minWidth: "17px", // Ancho mínimo del badge
                                    height: "17px", // Alto mínimo del badge
                                    padding: "0 3px", // Padding ajustado para el contenido
                                    transform: "translateX(32px)", // Desplaza el badge hacia la derecha
                                },
                            }}
                        >
                            <MenuItem
                                onClick={() => {
                                    setdataReclamo(row.original);
                                    setopenclose(true)
                                    // setNewUuid(row.original.uuid);
                                    // setOpenCloseAdj(!openCloseAdj);
                                    closeMenu();
                                }}
                            >
                                <ListItemIcon>
                                    <AttachFileIcon color="action" />
                                </ListItemIcon>
                                Adjuntos
                            </MenuItem>
                        </Badge>,
                        <MenuItem
                            disabled={
                                row.original.estado === 171 ||
                                row.original.estado === 223 ||
                                row.original.estado === 342
                            }
                            key={7}
                            onClick={() => {
                                setdataReclamo(row.original);
                                setEditar(true);
                                closeMenu();
                            }}
                        >
                            <ListItemIcon>
                                <EditIcon color="action" />
                            </ListItemIcon>
                            Editar
                        </MenuItem>,
                        <MenuItem
                            disabled={
                                row.original.estado !== 171 ||
                                localStorage.getItem("sector") === "13" // condición del sector (comercial granel no puede verlo)
                            }
                            key={8}
                            onClick={() => {
                                setdataReclamo(row.original);
                                setFacturar(true);
                                closeMenu();
                            }}
                        >
                            <ListItemIcon>
                                <ReceiptIcon color="secondary" />
                            </ListItemIcon>
                            Facturar
                        </MenuItem>,
                    ]}
                />
            }
            <br />
            <br /><br />
            {asignar ? (
                <AsignarTecnico2
                    datos={dataReclamo}
                    open={asignar} // Pasa el estado booleano
                    setOpen={setAsignar} // Pasa la función para actualizar el estado
                    tabla={setTabla}
                    actualizar={getReclamos}
                />
            ) : null}
            {confirmarGrua ? (
                <ConfirmarGrua
                    datos={dataReclamo}
                    open={confirmarGrua} // Pasa el estado booleano
                    setOpen={setConfirmarGrua} // Pasa la función para actualizar el estado
                    tabla={setTabla}
                    actualizar={getReclamos}
                />
            ) : null}
            {finalizar && (
                <FinalizarReclamo
                    key={`${dataReclamo.id_reclamo}_${dataReclamo.total_archivos}`}
                    datos={dataReclamo}
                    open={finalizar}
                    setOpen={setFinalizar}
                    tabla={setTabla}
                    actualizar={getReclamos} />
            )}
            {facturar && (
                <Facturado
                    datos={dataReclamo}
                    open={facturar} // Pasa el estado booleano
                    setOpen={setFacturar} // Pasa la función para actualizar el estado
                    tabla={setTabla}
                    actualizar={getReclamos}
                    onClose={handleCloseFacturar}
                />
            )}
            {editar && (
                <EditarReclamoInst
                    datos={dataReclamo}
                    open={editar}
                    setOpen={setEditar}
                    actualizar={getReclamos} />
            )}

            {cancelar ? (
                <CancelarReclamo2
                    datos={dataReclamo}
                    open={cancelar} // Pasa el estado booleano
                    setOpen={setCancelar} // Pasa la función para actualizar el estado
                    tabla={setTabla}
                    actualizar={getReclamos}
                    activeTab={props.activeTab}
                />
            ) : null}

            {openclose &&
                <UpdatedUploadFiles
                    fileId={dataReclamo.uuid}
                    open={openclose}
                    setOpen={setopenclose}
                    title={"Adjuntos"} />
            }

        </div>
    )
}